import React from "react";
import logo from "../assets/images/logo/logo.svg";

const MobileMenu = ({ activeMenu, setActiveMenu, onLinkClick }) => {
  const handleClick = (e, targetId) => {
    onLinkClick(e, targetId);
    setActiveMenu(false); // Ferme le menu après le clic
  };

  return (
      <>
        <div className="openmobile-menu fixed top-0 h-screen pt-10 pb-6 bg-white shadow-box2 w-[320px] overflow-y-auto flex flex-col z-[999] active-mobile-menu">
          <div className="flex justify-between px-6 flex-none">
            <a
                href="#home"
                onClick={(e) => handleClick(e, 'home')}
                className="brand-logo flex-none mr-10"
            >
              <img src={logo} alt="logo" />
            </a>
            <span
                className="text-3xl text-black cursor-pointer rt-mobile-menu-close"
                onClick={() => setActiveMenu(!activeMenu)}
            >
            <iconify-icon icon="fe:close"></iconify-icon>
          </span>
          </div>
          <div className="mobile-menu mt-6 flex-1">
            <ul className="menu-active-classes space-y-5 px-6">
              <li>
                <a
                    href="#why-vatel"
                    onClick={(e) => handleClick(e, 'why-vatel')}
                    className="text-black font-medium inline-block"
                >
                  Pourquoi Vatel ?
                </a>
              </li>
              <li>
                <a
                    href="#formations"
                    onClick={(e) => handleClick(e, 'formations')}
                    className="text-black font-medium inline-block"
                >
                  Formations
                </a>
              </li>
              <li>
                <a
                    href="#pedagogie"
                    onClick={(e) => handleClick(e, 'pedagogie')}
                    className="text-black font-medium inline-block"
                >
                  Pédagogie
                </a>
              </li>
              <li>
                <a
                    href="#tauxinsertion"
                    onClick={(e) => handleClick(e, 'tauxinsertion')}
                    className="text-black font-medium inline-block"
                >
                  Taux d'insertion
                </a>
              </li>
              <li>
                <a
                    id="btn-brochure-menu-mobile"
                    href="#brochure"
                    onClick={(e) => handleClick(e, 'brochure')}
                    className="btn btn-primary py-3 px-8 mt-4 w-full text-center inline-block"
                >
                  Brochure
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className={`rt-mobile-menu-overlay ${activeMenu && "active"}`}></div>
      </>
  );
};

export default MobileMenu;